import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from '@/shared/ui/sonner';

import { applyUpdate, usePwaUpdate } from './register';

const TOAST_ID = 'pwa-update';

/**
 * "A new version is available" while a new service worker waits: a toast that stays until the user updates (the page reloads
 * with the new build) or dismisses it (the new build takes over when every tab of the portal has been closed).
 */
export function PwaUpdatePrompt() {
  const { t } = useTranslation('app');
  const waiting = usePwaUpdate((state) => state.waiting);

  useEffect(() => {
    if (!waiting) return;
    toast(t('pwa.updateTitle'), {
      id: TOAST_ID,
      description: t('pwa.updateDescription'),
      duration: Infinity,
      action: { label: t('pwa.updateAction'), onClick: applyUpdate },
    });
    return () => {
      toast.dismiss(TOAST_ID);
    };
  }, [waiting, t]);

  return null;
}
